import { render, staticRenderFns } from "./PascalReminder.vue?vue&type=template&id=0c52a582&scoped=true&"
import script from "./PascalReminder.vue?vue&type=script&lang=js&"
export * from "./PascalReminder.vue?vue&type=script&lang=js&"
import style0 from "./PascalReminder.vue?vue&type=style&index=0&id=0c52a582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52a582",
  null
  
)

export default component.exports